export default __webpack_public_path__ + "static/media/green_eyes.302d4deb.png";